import { render, staticRenderFns } from "./select-students-dialog.vue?vue&type=template&id=5bc887ec&scoped=true"
import script from "./select-students-dialog.vue?vue&type=script&lang=js"
export * from "./select-students-dialog.vue?vue&type=script&lang=js"
import style0 from "./select-students-dialog.vue?vue&type=style&index=0&id=5bc887ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc887ec",
  null
  
)

export default component.exports